<div class="panel trailer-half">
    <span>Step 1.Choose area of interest</span>
    <mc-tabs id="mc-tabs" [tabs]="aoiTabs" (tabChanged)="onTabChange($event)">
        <div slot="tab_1">
            <mc-state #stateTab></mc-state>
        </div>
        <div slot="tab_2">
            <mc-region #regionTab [countySortField]="'name'"></mc-region>
        </div>
        <div slot="tab_3">
            <mc-route #routeTab [countySortField]="'name'"></mc-route>
        </div>
        <div slot="tab_4">
            <mc-asset-search #assetIdTab></mc-asset-search>
        </div>
        <div slot="tab_5">
            <mc-address #addressTab></mc-address>
        </div>
        <div slot="tab_6">
            <mc-lat-long #latLongTab></mc-lat-long>
        </div>
    </mc-tabs>
</div>
<div class="panel trailer-half">
    <div class="panel-header">
        <span>Step 2.</span>
        <label class="toggle-switch clearfix use-existing-map" *ngIf="hasExistingLayers">
            <span class="togggle-switch-label left font-size--1 margin-right-half">Use existing Map</span>
            <input type="checkbox" name="seperate" class="toggle-switch-input" [(ngModel)]="useExistingMap" checked (change)="existingMapChanged($event)">
            <span class="toggle-switch-track right"></span>
        </label>
        <span *ngIf="!hasExistingLayers">Select a map template</span>
    </div>
    <mc-map-picker #mapPicker [hidden]="hasExistingLayers && useExistingMap"></mc-map-picker>
</div>
<button class="btn btn-small" (click)="login($event)" *ngIf="!loggedIn" style="float: left">Log In</button>
<button class="btn btn-small" (click)="closeAoiTool()" style="float: right">Cancel</button>
<button class="btn btn-small margin-right-half" (click)="generateMap()" style="float: right">
    Generate Map
</button>